export class BaseResource {
    id?: string;
    tid?: string;
    type?: string;
}
